import { z } from "zod";

export const ExtendedConnectionStatus = {
  ONLINE: "online",
} as const;
export type ExtendedConnectionStatus = (typeof ExtendedConnectionStatus)[keyof typeof ExtendedConnectionStatus];

export const ExtendedPrepareResultSchema = z.object({
  prepareId: z.string(),
  messageToSign: z.string(),
});
export type ExtendedPrepareResultDto = z.infer<typeof ExtendedPrepareResultSchema>;

export const AddExtendedAccountSchema = z.object({
  accountId: z.number().int().positive(),
  walletAddress: z.string().min(1),
  status: z.string(),
});
export type AddExtendedAccountDto = z.infer<typeof AddExtendedAccountSchema>;
